<script setup lang="ts">
defineProps<{
  show: boolean
}>()

const emit = defineEmits<{
  click: []
}>()
</script>

<template>
  <Teleport to="body">
    <div
      v-show="show"
      class="backdrop"
      @click="emit('click')"
    />
  </Teleport>
</template>

<style lang="scss" scoped>
@use '@/assets/styles/helpers' as *;

.backdrop {
  @extend %stretch-fixed;

  background-color: var(--app-color-backdrop);
  z-index: 1;
}
</style>
